import React from 'react';
import NotificationItem from './NotificationItem';

const NotificationContainer = ({ notifications, removeNotification }) => {
    return (
        <div className="notification-container">
            {notifications.map(notification => (
                <NotificationItem
                    key={notification.id}
                    {...notification}
                    onClose={removeNotification}
                />
            ))}
        </div>
    );
};

export default NotificationContainer;
